import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { getQuestionUrl, getLearningObjectiveUrl } from 'utils/navigation';
import withNavigation from 'components/hocs/withNavigation';
import { getBackground, isPreviewMode } from 'store/settings/selectors';
import { getQuestionSection } from 'store/questions/selectors';
import {
  getCourseTitle,
  getCourseIntroductions,
  getPreviewQuestionId
} from 'store/course/selectors';
import { getSections, affectsProgress } from 'store/sections/selectors';
import SectionsListComponent from 'components/sections/SectionsList';
import CourseInformation from 'components/sections/CourseInformation';
import { localize } from 'core/localization';
import { clearPreviewQuestionId } from 'store/course/actions';
import {
  SectionsPageContainer,
  SectionListContainer,
  SectionsPageSidebar,
  SectionsPageContent
} from './SectionsPage.styled';
import { RootAppState } from 'store/types';

type SectionsProps = {
  sections: any[];
  navigateToUrl(url: string): void;
  isAccessLimited: boolean;
  previewQuestionId: string;
  previewSectionId: string;
  clearPreviewQuestionIdAction(): void;
  theme: { [key: string]: any };
  background: { [key: string]: any };
  title: string;
};
export class Sections extends React.Component<SectionsProps, {}> {
  navigateToQuestion = (sectionId: string, questionId: string) => {
    this.props.navigateToUrl(getQuestionUrl(sectionId, questionId));
  };

  navigateToLearningObjective = (sectionId: string) => {
    this.props.navigateToUrl(getLearningObjectiveUrl(sectionId));
  };

  componentDidMount() {
    if (this.props.previewQuestionId) {
      this.props.clearPreviewQuestionIdAction();
      this.navigateToQuestion(this.props.previewSectionId, this.props.previewQuestionId);
    }

    document.title = `${localize('[section page title]')} | ${this.props.title}`;
  }

  render() {
    const { sections, background } = this.props;
    return (
      <SectionsPageContainer>
        <SectionsPageSidebar background={background}>
          <CourseInformation sections={sections} />
        </SectionsPageSidebar>
        <SectionsPageContent background={background}>
          <SectionListContainer>
            <SectionsListComponent
              sections={sections}
              navigateToQuestion={this.navigateToQuestion}
              navigateToLearningObjective={this.navigateToLearningObjective}
            />
          </SectionListContainer>
        </SectionsPageContent>
      </SectionsPageContainer>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return { clearPreviewQuestionIdAction: bindActionCreators(clearPreviewQuestionId, dispatch) };
}

function mapStateToProps(state: RootAppState) {
  const props: {[key: string]: any} = {
    title: getCourseTitle(state),
    introductions: getCourseIntroductions(state),
    sections: getSections(state).map(section => ({
      ...section,
      affectsProgress: affectsProgress(state, section.id)
    })),
    background: getBackground(state)
  };

  const previewQuestionId = getPreviewQuestionId(state);
  if (isPreviewMode(state) && previewQuestionId) {
    props.previewQuestionId = previewQuestionId;
    props.previewSectionId = getQuestionSection(state, props.previewQuestionId);
  }

  return props;
}

export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(Sections));
